import { render } from "./ContainerRegistryConfigurationForm.vue?vue&type=template&id=8de3893e&ts=true"
import script from "./ContainerRegistryConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./ContainerRegistryConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__